/**
 * Options for the site's 3rd Party Network Provider. Shared by the Site Documentation
 * field, the partner import, and the rules engine condition, so adding a provider here
 * updates every surface. Ids are persisted; never rename one.
 */
export const THIRD_PARTY_NETWORK_PROVIDERS = [
    { label: 'Access Networks', id: '3rd_party_network_access_networks' },
    { label: 'Araknis', id: '3rd_party_network_araknis' },
    { label: 'Not Applicable', id: '3rd_party_network_not_applicable' },
    { label: 'O&O IT', id: '3rd_party_network_oo_it' },
    { label: 'Other - In Notes', id: '3rd_party_network_other' },
    { label: 'Parasol', id: '3rd_party_network_parasol' },
    { label: 'WhyReboot', id: '3rd_party_network_whyreboot' },
];
